import { useEffect } from 'react';

const WORK_HERO_IMAGE = 'https://storage.readdy-site.link/project_files/65efda26-2ca3-4c72-9a10-ece388165e01/70cb5066-60f7-4401-b379-c438caacdff9_WhatsApp-Image-2026-05-24-at-20.41.41-5.jpeg?v=29741f1fde822bf89af4aabf24324597';

const CALENDLY_URL = 'https://paystack.com/buy/private-clarity-call-sdonrr';

export default function WorkHeroSection() {
  useEffect(() => {
    document.title = 'Work With Me | MANDIE OZEE.';
  }, []);

  return (
    <section className="relative bg-[#FDFAF8] min-h-[60vh] md:min-h-[80vh] flex items-center overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src={WORK_HERO_IMAGE}
          alt="Mandie Ozee, Transformation Coach"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/10 to-black/40 z-[1]" />
      </div>

      <div className="relative z-[2] w-full px-4 md:px-8 lg:px-12 py-24 md:py-32">
        <div className="max-w-4xl mx-auto text-center">
          {/* Eyebrow */}
          <p className="text-[#C9A84C] text-xs font-body tracking-[0.25em] uppercase mb-6">
            The coaching suite
          </p>

          {/* Headline */}
          <h1 className="font-heading text-xl md:text-2xl lg:text-4xl text-[#1A1A1A] leading-tight mb-6">
    The work that changes everything
    <br />
    starts with one conversation.
          </h1>

          {/* Subheadline */}
          <p className="font-quote text-base md:text-lg italic text-[#D4006A] mb-10">
            Every offer. One direction. Home.
          </p>

          {/* CTA Button */}
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-8 py-4 bg-[#D4006A] text-white text-sm font-body font-medium rounded-full hover:bg-[#B3005A] transition-colors duration-300 whitespace-nowrap w-auto mx-auto"
          >
  Book a Clarity Call
</a>
<p className="text-xs text-[#D0C0C8] text-center mt-2">
  <a href="https://paystack.com/buy/private-clarity-call-sdonrr" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#C9A84C]">Book a Private Clarity Call</a>
</p>
        </div>
      </div>
    </section>
  );
}